import React, { Component } from "react";
import { FontAwesomeIcon }            from '@fortawesome/react-fontawesome'
import { Button, FormControl, ListGroup, ListGroupItem, Modal } from "react-bootstrap";
import { invokeSetCreateReminder }    from "../../utils/AwsInvoke";
import { Colors }                     from "../../utils/Colors";
import KeywordsInput                  from "../../components/exercise/KeywordsInput";
import LoaderButton                   from "../../components/LoaderButton";
import YouTubeThumbnail               from "../../components/YouTubeThumbnail";
import uniqueId                       from 'lodash/uniqueId';
import { invokeEditNameBlockTemplate } from "../../utils/AwsInvoke";

export default class ModalEditBlockName extends Component {

    constructor(props) {
        super(props);

        this.state = {
            error: "",
            block_name: ""
        };
    }
    componentDidMount () {
        this.setState({
            block_name: this.props.block_name
        })
    }
    handleSubmit = async event => {

        this.setState({ isLoading: true })

        var block_id   = this.props.block_id
        var block_name = this.state.block_name;

        if(block_name == "") {
            this.setState({
                error: "A block name can't be empty.",
                isLoading: false
            })

        } else {
            const results = await invokeEditNameBlockTemplate(block_id, block_name);

            if(results.status) {
                this.props.handleFinishedModalEditBlockName();
                //this.props.onHide();
            } else
                this.setState({
                    error: "Ooops, looks like there was an error. Try again.",
                    isLoading: false
                })
        }
    }

    handleKeyPress = (target) => {
        // Allow user to hit "Enter" when using Search box //
         if(target.charCode === 13) {
             this.props.onHide();
             this.handleSubmit();
        }
    }

    cancel () {
        this.props.onHide();
    }


    handleCustomChange(event) {
        var name = event.target.value;
        this.setState({
            block_name: name
        })
    }

    render() {
        var message = this.state.message;
        var error   = this.state.error;

        return (
            <Modal
                show      = {true /*this.state.showModalSearchKeywords*/ }
                onHide    = {this.props.onHide}
                className = "modalEditBlockName"
              >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title" className="fontSize26px">
                        { /*}<FontAwesomeIcon icon="search"
                                         className="modalBasicsTitleIcon"
                                         style={{ position:"relative", color: Colors.primary_color}}/>*/ }
                        <span className="modalBasicsTitle">
                             EDIT BLOCK TEMPLATE NAME
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <span className="modalBasicsBodySearchKeywor">
                          <div>
                              <div className="modalFormLabelBody">Name</div>
                                  <span>
                                      <input type="text"
                                             placeholder = ""
                                             value     = {this.state.block_name}
                                             onChange  = {this.handleCustomChange.bind(this)}
                                             className = "input-lg blockNameField" />
                                </span>
                          </div>
                          <span style={{position: "relative", top: 8, fontSize: 16, color: "red"}}>{error}</span>
                    </span>
                    <br/>

                </Modal.Body>
                <Modal.Footer>
                    <span>
                        <LoaderButton
                          height     = {38}
                          width      = {150}
                          btncolor   = { Colors.cancel_button_bg }
                          type       = "button"
                          text       = "Cancel"
                          className  = "modalBasicsBtnClose"
                          onClick    = { () => this.cancel()}
                        />
                        <LoaderButton
                            bsSize      = "large"
                            btncolor    = "#09c141"
                            height      = {38}
                            width       = {120}
                            isLoading   = {this.state.isLoading}
                            text        = "Submit"
                            loadingText = ""
                            onClick     = {() => this.handleSubmit()}
                          />
                    </span>
                </Modal.Footer>

              </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/ModalEditBlockName.js